import React from "react";
import styled, { keyframes } from "styled-components";
import { Theme } from "../../Theme";

const CustomPercentCircleChart = ({ percentage = 82, size = 200, strokeWidth = 20 }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    // 82%에 해당하는 선의 길이 계산
    const offset = circumference - (percentage / 100) * circumference;

    return (
        <Container size={size}>
            <Svg width={size} height={size}>
                {/* 배경 원 (연한 색상) */}
                <BackgroundCircle cx={size / 2} cy={size / 2} r={radius} strokeWidth={strokeWidth} />
                {/* 진행 원 (진한 색상) */}
                <ProgressBarCircle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                />
            </Svg>
            <PercentageText>{percentage}%</PercentageText>
        </Container>
    );
};

export default CustomPercentCircleChart;

// --- 스타일 컴포넌트 ---

const progressAnimation = (offset) => keyframes`
  from { stroke-dashoffset: ${2 * Math.PI * 90}; } // 시작점 (원주율 임의값)
  to { stroke-dashoffset: ${offset}; }
`;

const Container = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    border-radius: 20px; /* 컨테이너 둥글기 */
`;

const Svg = styled.svg`
    transform: rotate(-90deg); /* 12시 방향에서 시작하도록 회전 */
`;

const BackgroundCircle = styled.circle`
    fill: none;
    stroke: ${Theme.color.white_01}; /* 배경이 되는 연한 원 */
`;

const ProgressBarCircle = styled.circle`
    fill: none;
    stroke: #c2bcff; /* 실제 진행률을 나타내는 밝은 색상 */
    stroke-linecap: round; /* 선의 끝을 둥글게 처리 */
    transition: stroke-dashoffset 1s ease-in-out;
    animation: ${(props) => progressAnimation(props.strokeDashoffset)} 1s ease-in-out;
`;

const PercentageText = styled.div`
    position: absolute;
    font-size: 21px;
    font-weight: 700;
    color: ${Theme.color.violet100};
    font-family: sans-serif;
`;
